import React, { useState } from 'react';

const AgeGate = ({ onVerified }) => {
  const [month, setMonth] = useState('');
  const [day, setDay] = useState('');
  const [year, setYear] = useState('');
  const [error, setError] = useState('');
  const [rejected, setRejected] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    const m = parseInt(month);
    const d = parseInt(day);
    const y = parseInt(year);

    if (!month || isNaN(m) || m < 1 || m > 12) return setError('te rugăm să introduci o lună validă');
    if (!day || isNaN(d) || d < 1 || d > 31) return setError('te rugăm să introduci o zi validă');
    if (!year || isNaN(y) || year.length !== 4 || y < 1900) return setError('te rugăm să introduci un an valid');

    const birthDate = new Date(y, m - 1, d);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) age--;

    if (age >= 18) {
      // Set to expire in 24 hours
      const expiry = new Date().getTime() + 24 * 60 * 60 * 1000;
      localStorage.setItem('seltz_age_verified', 'true');
      localStorage.setItem('seltz_age_verified_expiry', expiry.toString());
      onVerified();
    } else {
      setRejected(true);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center"
      style={{
        background: 'linear-gradient(135deg, #0f0f0f 0%, #0a0a0a 50%, #1a1a1a 100%)',
      }}
    >
      {/* Grainy texture overlay */}
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.4'/%3E%3C/svg%3E")`,
        }}
      />

      <div className="relative z-10 flex flex-col items-center text-center px-4 sm:px-6 w-full" style={{ maxWidth: '360px' }}>
        {/* Logo */}
        <div className="mb-8 sm:mb-10">
          <span
            className="text-white font-black text-3xl sm:text-4xl tracking-wider"
            style={{ fontFamily: 'Nunito, sans-serif' }}
          >
            SELTZ
          </span>
        </div>

        {rejected ? (
          <div className="text-white">
            <h2
              className="text-3xl sm:text-4xl font-black italic mb-4"
              style={{ fontFamily: 'Nunito, sans-serif' }}
            >
              Oops!
            </h2>
            <p className="text-white/80 text-sm sm:text-base leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif' }}>
              Îți mulțumim pentru interesul acordat Seltz. Te rugăm să revii când vei avea vârsta legală pentru a consuma alcool.
            </p>
          </div>
        ) : (
          <>
            <h2
              className="text-white text-xl sm:text-2xl font-black italic mb-6 sm:mb-8"
              style={{ fontFamily: 'Nunito, sans-serif' }}
            >
              te rugăm să introduci data nașterii
            </h2>

            <form onSubmit={handleSubmit} className="w-full flex flex-col gap-3 sm:gap-4">
              <div className="grid grid-cols-3 gap-2 sm:gap-3">
                <input
                  type="text"
                  placeholder="LL"
                  maxLength={2}
                  value={month}
                  onChange={(e) => setMonth(e.target.value.replace(/\D/g, ''))}
                  className="min-w-0 bg-white/15 border border-white/40 rounded-xl sm:rounded-2xl px-2 sm:px-3 py-3 sm:py-4 text-white placeholder-white/50 text-center text-base sm:text-lg font-bold focus:outline-none focus:border-white focus:bg-white/20 transition-all"
                  style={{ fontFamily: 'Nunito, sans-serif' }}
                  data-testid="age-gate-month"
                />
                <input
                  type="text"
                  placeholder="ZZ"
                  maxLength={2}
                  value={day}
                  onChange={(e) => setDay(e.target.value.replace(/\D/g, ''))}
                  className="min-w-0 bg-white/15 border border-white/40 rounded-xl sm:rounded-2xl px-2 sm:px-3 py-3 sm:py-4 text-white placeholder-white/50 text-center text-base sm:text-lg font-bold focus:outline-none focus:border-white focus:bg-white/20 transition-all"
                  style={{ fontFamily: 'Nunito, sans-serif' }}
                  data-testid="age-gate-day"
                />
                <input
                  type="text"
                  placeholder="AAAA"
                  maxLength={4}
                  value={year}
                  onChange={(e) => setYear(e.target.value.replace(/\D/g, ''))}
                  className="min-w-0 bg-white/15 border border-white/40 rounded-xl sm:rounded-2xl px-2 sm:px-3 py-3 sm:py-4 text-white placeholder-white/50 text-center text-base sm:text-lg font-bold focus:outline-none focus:border-white focus:bg-white/20 transition-all"
                  style={{ fontFamily: 'Nunito, sans-serif' }}
                  data-testid="age-gate-year"
                />
              </div>

              {error && (
                <p className="text-yellow-300 text-sm font-bold" style={{ fontFamily: 'Nunito, sans-serif' }}>
                  {error}
                </p>
              )}

              <button
                type="submit"
                data-testid="age-gate-submit"
                className="w-full bg-white text-[#0a0a0a] font-black text-sm sm:text-base py-3 sm:py-4 rounded-xl sm:rounded-2xl hover:bg-white/90 transition-colors mt-1 sm:mt-2 shadow-lg"
                style={{ fontFamily: 'Nunito, sans-serif' }}
              >
                trimite
              </button>
            </form>

            <p className="text-white/50 text-xs mt-4 sm:mt-6 leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif' }}>
              Trebuie să ai vârsta legală pentru consumul de alcool din țara ta pentru a intra. Prin intrare, accepți termenii noștri de utilizare și politica noastră de confidențialitate. Recomandăm consumul responsabil.
            </p>
          </>
        )}

        <p className="text-white/30 text-xs mt-6 sm:mt-8 leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif' }}>
          Consumați cu moderație. © 2024 Seltz™ Premium Vodka Soda cu suc natural de fructe, apă minerală și arome naturale, 4.5% Alc. pe Vol.
        </p>
      </div>
    </div>
  );
};

export default AgeGate;
